/*
 * Copyright (c) 2019 - Bas Milius <bas@mili.us>
 *
 * This file is part of the Latte Framework package.
 *
 * For the full copyright and license information, please view the
 * LICENSE file that was distributed with this source code.
 */

export function registerServiceWorker()
{
	if (!("serviceWorker" in navigator))
		throw new Error("Could not install service worker! It's not supported by the browser.");

	if (!window.isSecureContext)
		throw new Error("Could not install service worker! We're not in a secure context.");

	navigator.serviceWorker.getRegistration().then(registration =>
	{
		if (registration !== undefined)
			return onRegistrationFound(registration);

		navigator.serviceWorker.register("/service-worker.js")
			.then(registration => onRegistrationFound(registration))
			.catch(err => Latte.core.handleError(err));
	});

	Latte.action.on("latte:service-worker:update-now", () => window.location.reload());
}

function onRegistrationFound(registration)
{
	Latte.action.dispatch("latte:service-worker:registration-available", registration);

	registration.addEventListener("updatefound", evt => onUpdateFound(evt));
}

function onUpdateFound(evt)
{
	const installingServiceWorker = evt.target.installing;

	installingServiceWorker.addEventListener("statechange", () =>
	{
		if (installingServiceWorker.state !== "installed" || !navigator.serviceWorker.controller)
			return;

		Latte.action.dispatch("latte:service-worker:update-found", evt);
		Latte.ui.notification.create({
			duration: 0,
			color: "info",
			icon: "information",
			title: Latte.i18n.translate("root", "Update found!"),
			message: Latte.i18n.translate("root", "There is a new update available! Refresh the page or click the Update now button to update."),
			buttons: [
				{
					params: {action: "latte:service-worker:update-now"},
					color: "primary",
					label: Latte.i18n.translate("root", "Update now")
				},
				{
					params: {action: "latte:service-worker:update-later"},
					color: "dark",
					label: Latte.i18n.translate("root", "Later")
				}
			]
		});
	});
}
